<ng-select
  [items]="allVoiceNames"
  [clearable]="false"
  bindLabel="title"
  bindValue="value"
  [formControl]="voiceName"
  placeholder=""
></ng-select>

